import React, { useState, } from 'react';
// import './story.css';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from 'sweetalert';

const Addrehab = () => {

    const [name, setName] = useState('');
    const [location, setLocation] = useState('');
    const [about, setAbout] = useState('');
    const [email, setEmail] = useState('');
    const [phno,setPhno] = useState('');
    const [review1,setReview1] = useState('');
    const [review2,setReview2] = useState('');
    const [review3,setReview3] = useState('');

    


    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {
            
        // }
        // f();
        const Rehab = Parse.Object.extend('Rehab');
            const rehab = new Rehab();
    
            rehab.set("name", name);
            rehab.set("location", location);
            rehab.set("about",about);
            rehab.set("email",email);
            rehab.set("phno",phno);
            rehab.set("review1",review1);
            rehab.set("review2",review2);
            rehab.set("review3",review3);

        
    
            rehab.save()
                .then((data) => {
                    console.log(data);
                    swal("Success","Centre has been added");
                    // this.props.history.push('/familystories/route');
                }).catch((error) => {
                    console.log(error);
                    swal("Oops!","Sorry we could not add the centre please try later");
                })        

    }
    return (
        <div>
            <Navbar head="Add New Rehab " />
            <div className="container " style={{marginTop:"70px"}}>
                <form onSubmit={handleSubmit}>

                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            required
                            onChange={e => setName(e.target.value)}
                            placeholder="Rehab name" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={location}
                            onChange={e => setLocation(e.target.value)}
                            placeholder="Rehab location"
                            required
                             />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={about}
                            onChange={e => setAbout(e.target.value)}
                            placeholder="about rehab"
                            disabled />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="email" 
                            />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="number"
                            className="form-control"
                            value={phno}
                            onChange={e => setPhno(e.target.value)}
                            placeholder="contact number" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <textarea
                            className="form-control"
                            value={review1}
                            rows="3"
                            onChange={e => setReview1(e.target.value)}
                            placeholder="Review 1"
                            required />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <textarea
                            className="form-control"
                            value={review2}
                            rows="3"
                            onChange={e => setReview2(e.target.value)}
                            placeholder="Review 2" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <textarea
                            className="form-control"
                            value={review3}
                            rows="3"
                            onChange={e => setReview3(e.target.value)}
                            placeholder="Review 3" />
                    </div>
                    <div className="btndiv">
                        <input
                        type="submit"
                            className="submit btn-primary center-block mt-4" />
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Addrehab;